// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_iTQ","cls2":"FocusedNavView-cls2_IC5 FocusedNavView-cls1_iTQ"};